<template>
  <div v-show="active" class="pay-qr-danmaku" aria-hidden="true">
    <span
      v-for="item in items"
      :key="item.id"
      class="pay-qr-danmaku__item"
      :style="item.style"
    >{{ text }}</span>
  </div>
</template>

<script>
const LANE_COUNT = 10
const PER_LANE = 4
const START_OFFSET = 'calc(100vw + 100% + 80px)'

export default {
  name: 'PayQrDanmaku',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '请再次核对主播信息，信息错误无法售后！'
    }
  },
  data() {
    return {
      items: []
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(val) {
        if (val) {
          this.items = this.buildItems()
        }
      }
    }
  },
  mounted() {
    if (this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el)
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  },
  methods: {
    buildItems() {
      const list = []
      let seq = 0
      for (let lane = 0; lane < LANE_COUNT; lane += 1) {
        for (let j = 0; j < PER_LANE; j += 1) {
          const top = 4 + lane * 9 + Math.random() * 2.5
          const duration = 5.5 + Math.random() * 3.5
          const delay = j * 1.6 + lane * 0.25 + Math.random() * 0.4
          const fontSize = 22 + Math.floor(Math.random() * 10)
          list.push({
            id: `danmaku-${seq}`,
            style: {
              top: `${Math.min(top, 93)}%`,
              animationDuration: `${duration}s`,
              animationDelay: `${delay}s`,
              fontSize: `${fontSize}px`,
              transform: `translateX(${START_OFFSET})`
            }
          })
          seq += 1
        }
      }
      return list
    }
  }
}
</script>

<style scoped>
.pay-qr-danmaku {
  position: fixed;
  inset: 0;
  z-index: 10050;
  overflow: hidden;
  pointer-events: none;
}

.pay-qr-danmaku__item {
  position: absolute;
  left: 0;
  white-space: nowrap;
  font-weight: 800;
  letter-spacing: 0.05em;
  color: #ff5cad;
  -webkit-text-stroke: 0.4px rgba(255, 255, 255, 0.85);
  text-shadow:
    0 0 3px #fff,
    0 0 8px #fff,
    0 0 14px rgba(255, 255, 255, 1),
    0 0 22px rgba(255, 255, 255, 0.9),
    0 0 34px rgba(255, 255, 255, 0.65);
  animation: pay-qr-danmaku-scroll linear infinite;
  animation-fill-mode: backwards;
  will-change: transform;
}
</style>

<style>
@keyframes pay-qr-danmaku-scroll {
  from {
    transform: translateX(calc(100vw + 100% + 80px));
  }
  to {
    transform: translateX(calc(-100% - 40px));
  }
}
</style>
